import { Component, Input, OnInit, ViewChild, Host, Optional, Injector } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { EasyFormComponent } from '../form/form.component';
import { FMSUtilityService } from '../../services/utility/utility.service';
import { FormGroupComponent } from '../form-group/form-group.component';
import { FormErrorComponent } from '../error/error.component';
import { BaseInputComponent } from '../base-input/base-input.component';
import { LocalizePipe } from '../../../../pipes/Localize.pipe';

@Component({
    selector: 'dateInput',
    templateUrl: 'date-input.component.html',
    styleUrls: [
        '../base-input/base-input.component.css'
    ]
})
export class DateInputComponent extends BaseInputComponent implements OnInit {


    get familyId() { return 'input'; }

    @Input() options: any;
    @Input() selDate: any;

    get date() {
        let v = this.formControl && this.formControl.value;
        console.log('get', v);
        return v;
    }

    set date(value) {
        //console.log('set', value);
        if (value) {
            if (typeof value != "string") value = value.formatted;
            this.formControl && this.formControl.setValue(value);
        }
    }

    constructor( @Host() parentForm: EasyFormComponent, @Optional() @Host() parentFormGroup: FormGroupComponent, protected injector: Injector) {
        super(parentForm, parentFormGroup, injector);
    }

    childOnInit() {
        if (this.formControl) {
            this.formControl.setValue(this.selDate);
        }
    }

    onDateChanged($event) {
        console.log($event);
        if ($event.date && this.formControl) {
            let d = new Date($event.date.year, $event.date.month, $event.date.day).toISOString();
            console.log(d);
            this.formControl.setValue(d);
        }
        this.onChanges.emit($event);
    }


}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/date-input/date-input.component.ts